import { render, staticRenderFns } from "./BranchesTable.vue?vue&type=template&id=fa84ec64&"
import script from "./BranchesTable.vue?vue&type=script&lang=js&"
export * from "./BranchesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports